// src/components/admin/AdminLoginPage.js
import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebaseConfig";
import "./AdminLoginPage.css"; // Create this file for your styling

const AdminLoginPage = ({ onLoginSuccess }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email.trim() || !password.trim()) {
            return alert("Both email and password are required.");
        }
        try {
            await signInWithEmailAndPassword(auth, email, password);
            alert("Login successful!");
            onLoginSuccess();
        } catch (error) {
            alert("Login failed: " + error.message);
        }
    };

    return (
        <div className="admin-login-container">
            <h2>Admin Login</h2>
            <form onSubmit={handleSubmit} className="admin-login-form">
                <div className="input-group">
                    <label htmlFor="admin-email">Email:</label>
                    <input
                        type="email"
                        id="admin-email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your admin email"
                        required
                    />
                </div>
                <div className="input-group">
                    <label htmlFor="admin-password">Password:</label>
                    <input
                        type="password"
                        id="admin-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Enter your password"
                        required
                    />
                </div>
                <button type="submit" className="login-button">
                    Login
                </button>
            </form>
        </div>
    );
};

export default AdminLoginPage;
